// Module
var code = `<div class="link-label-container {{#if links.length === 1}}single-link{{/if}}">
    {{#each links: i}}
        {{#if links[i].linkHref !== '-1'}}
            <terceraLinkLabel 
                subclass="{{#if i === 0}}alignToRight{{else}}alignToLeft{{/if}}"
                text="{{links[i].text || links[i].linkHref}}" 
                tooltip="{{tooltips[i]}}" 
                name="{{links[i].name}}" 
                linkHref="{{links[i].linkHref}}" />
            {{#if i !== links.length - 1}}
                <div class="link-separator"></div>
            {{/if}}
        {{/if}}
    {{/each}}
</div>
`;
// Exports
export default code;